import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { FraudulentTransactionResolver } from './modules/admin/transaction/transaction.resolvers';
import { campaignDataResolver } from './modules/admin/campaign/campaign.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () =>
                    import(
                        'app/modules/auth/confirmation-required/confirmation-required.routes'
                    ),
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/forgot-password/forgot-password.routes'
                    ),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/reset-password/reset-password.routes'
                    ),
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
            {
                path: 'sign-up',
                loadChildren: () =>
                    import('app/modules/auth/sign-up/sign-up.routes'),
            },
        ],
    },
    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.routes'),
            },
            {
                path: 'unlock-session',
                loadChildren: () =>
                    import(
                        'app/modules/auth/unlock-session/unlock-session.routes'
                    ),
            },
        ],
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        data: {
            layout: 'ekedai',
        },
        children: [
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('app/modules/admin/dashboard/dashboard.routes'),
            },
            // {
            //     path: 'summary',
            //     loadChildren: () =>
            //         import('app/modules/admin/summary/summary.routes'),
            // },
            {
                path: 'bill',
                loadChildren: () =>
                    import('app/modules/admin/bill/bill.routes'),
            },
            {
                path: 'profile-settings',
                loadChildren: () =>
                    import(
                        'app/modules/admin/profile-settings/profile-settings.routes'
                    ),
            },
            {
                path: 'administration',
                loadChildren: () =>
                    import(
                        'app/modules/admin/site-administration/site-administration.routes'
                    ),
            },
            {
                path: 'prepaid',
                loadChildren: () =>
                    import('app/modules/admin/prepaid/product-list.routes'),
            },
            {
                path: 'postpaid',
                loadChildren: () =>
                    import('app/modules/admin/prepaid/product-list.routes'),
            },
            {
                path: 'electricity',
                loadChildren: () =>
                    import('app/modules/admin/prepaid/product-list.routes'),
            },
            {
                path: 'water',
                loadChildren: () =>
                    import('app/modules/admin/prepaid/product-list.routes'),
            },
            {
                path: 'gas',
                loadChildren: () =>
                    import('app/modules/admin/prepaid/product-list.routes'),
            },
            {
                path: 'music',
                loadChildren: () =>
                    import('app/modules/admin/prepaid/product-list.routes'),
            },
            {
                path: 'stream-services',
                loadChildren: () =>
                    import('app/modules/admin/prepaid/product-list.routes'),
            },
            {
                path: 'game',
                loadChildren: () =>
                    import('app/modules/admin/prepaid/product-list.routes'),
            },
            {
                path: 'entertainment',
                loadChildren: () =>
                    import('app/modules/admin/prepaid/product-list.routes'),
            },
            {
                path: 'product-list',
                loadChildren: () =>
                    import('app/modules/admin/prepaid/product-list.routes'),
            },
            {
                path: 'incomplete',
                loadChildren: () =>
                    import('app/modules/admin/prepaid/product-list.routes'),
            },
            {
                path: 'app-management',
                loadChildren: () =>
                    import(
                        'app/modules/admin/app-management/app-management.routes'
                    ),
            },
            // {
            //     path: 'loyalty',
            //     loadChildren: () =>
            //         import('app/modules/admin/loyalty/loyalty.routes'),
            // },
            // {
            //     path: 'discount',
            //     loadChildren: () =>
            //         import('app/modules/admin/discount/discount.routes'),
            // },
            // {
            //     path: 'customer',
            //     loadChildren: () =>
            //         import('app/modules/admin/customer/customer.routes'),
            // },
            // {
            //     path: 'analytics',
            //     loadChildren: () =>
            //         import('app/modules/admin//analytics/analytics.routes'),
            // },
            {
                path: 'transaction-list',
                loadChildren: () =>
                    import('app/modules/admin/transaction/transaction.routes'),
            },
            // {
            //     path: 'transaction-verification',
            //     loadComponent: () => import('./modules/admin/fraudulent-transaction/fraudulent-transaction.component').then((m) => m.FraudulentTransactionComponent),
            //     resolve: {
            //         FraudulentTransactionResolver
            //     }
            // },
            // {
            //     path: 'campaign',
            //     loadComponent: () => import('./modules/admin/campaign/campaign.component').then((m) => m.CampaignComponent),
            //     resolve: {
            //         campaignDataResolver
            //     }
            // },
            {
                path: 'wallet',
                loadChildren: () => import('app/modules/admin/wallet/wallet.routes').then(m => m.walletRoutes),
            },
        ],
    },
    { path: '**', redirectTo: 'dashboard' },
];
